import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import SummaryRow from './SummaryRow';

export interface MeetingCancellationSummaryProps {
    item: MeetingCancellationMessageType;
}

const MeetingCancellationSummary = observer(function MeetingCancellationSummary(
    props: MeetingCancellationSummaryProps
) {
    return <SummaryRow item={props.item} />;
});

export default MeetingCancellationSummary;
